var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"expireat"},_vm._l((_vm.tagLists),function(tag,index){return _c('div',{key:("tag-" + index),staticClass:"expireat--item",style:({ '--bg-c': tag.package === 'basic' || tag.package === 'expired' ? 'gray' : 'red' })},[_vm._v("\n    "+_vm._s(tag.text)+"\n  ")])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a566ef4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view/allbots/TagAllbot.vue
// module id = null
// module chunks = 